import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=128a0ee2&scoped=true&"
import script from "./personal-center.vue?vue&type=script&lang=js&"
export * from "./personal-center.vue?vue&type=script&lang=js&"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=128a0ee2&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a0ee2",
  null
  
)

export default component.exports